import styled from 'styled-components'

export const FAQContainer = styled.div`
  margin: 2rem 0;
`

export const FAQItem = styled.div`
  margin-bottom: 1rem;
  border: 1px solid ${({ theme }) => theme.palette.border.main};
  border-radius: 8px;
  overflow: hidden;
`
export const FAQHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  background-color: ${({ theme }) => theme.palette.background.paper};
`

export const FAQTitle = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.palette.text.primary};
`

export const FAQContent = styled.div<{ isOpen: boolean }>`
  height: ${({ isOpen }) => (isOpen ? 'auto' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: ${({ isOpen }) => (isOpen ? '1rem' : '0 1rem')};
  background-color: ${({ theme }) => theme.palette.background.default};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  margin: 0;
  overflow: hidden;
  border: none;
  min-height: 0;
`

export const FAQText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`
